import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useRequestProcessor } from "../../requestProcessor";
import { ReloadData } from "../../QueryFunctions/queryfunction";

import { App } from "@capacitor/app";

const Reload = () => {
  const navigate = useNavigate();
  const { useMutationWrapper } = useRequestProcessor();
  const reloadData = useMutationWrapper(
    "reload",
    () => {
      return ReloadData(navigate);
    },
    {
      onSuccess: (data) => {
        console.log("[Reload] Reload child data response:", data);
      },
    }
  );

  const check_date = (date) => {
    console.log("Checking date => ", date);
    const givenDate = new Date(date);
    const today = new Date();
    givenDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    console.log("Given Date => ", givenDate, " === ", today);
    return givenDate.getTime() === today.getTime();
  };

  useEffect(() => {
    console.log("[Reload] Setting up appStateChange listener...");

    const handleReload = async () => {
      console.log("[Reload] Running reload check on app start or resume...");

      const token = localStorage.getItem("auth_token");
      const reloadTime = localStorage.getItem("last_reload_time");
      const survey = localStorage.getItem("survey_id");

      console.log("[Reload] Auth Token:", token);
      console.log("[Reload] Reload Time:", reloadTime);
      console.log("[Reload] Survey ID:", survey);

      if (!reloadTime) {
        console.log("[Reload] No last_reload_time found. Skipping reload.");
        return;
      }

      if (token && token != '""') {
        console.log("[Reload] Auth Token:", token);

        const shouldReload = !check_date(reloadTime);
        if (shouldReload) {
          console.log("[Reload] Date check failed. Reloading data...");
          reloadData.mutate();
        } else if (survey && survey > 0) {
          console.log("[Reload] Redirecting to survey:", survey);
          navigate(`/survey/${survey}`);
        }
      } else {
        console.log("[Reload] No auth token. Removing listeners.");
        await App.removeAllListeners();
      }
    };

    // Run on first load
    handleReload();

    // Also run on app resume
    const listener = App.addListener("appStateChange", ({ isActive }) => {
      console.log("[Reload] appStateChange =>", isActive);
      if (isActive) handleReload();
    });

    return () => {
      console.log("[Reload] Cleaning up appStateChange listener...");
      listener.remove();
    };
  }, []);

  return null;
};

export default Reload;
